export const fillTechnologiesSlide = (filterTechnologies: any[], isDesktop: boolean) => {
  const nextMultiple = Math.ceil(filterTechnologies.length / 3) * 3 - filterTechnologies.length;
  return filterTechnologies.length > 3 && isDesktop ? [...filterTechnologies, ...Array(nextMultiple).fill(null)] : filterTechnologies;
}
